import { queryStringValuesRetriever } from "../utility";
//Open full screen
export function openContentFullScreen(currentElem, search) {
  // hideAndShowLeftSideBar(true);
  const elem = currentElem.current;
  if (search != "" && search != null && search != undefined) {
    const values = queryStringValuesRetriever(search);

    if (values.utm_source != "trusted-web-activity") {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (elem.requestFullScreen) {
          elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullscreen();
        }
      }
    }
  } else {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (elem.requestFullScreen) {
        elem.requestFullScreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    }
  }
}

//Exit full screen
export function exitContentFullScreen(currentElem = false) {
  /* let elem = document.querySelector('.content'); */

  /* Access the element of "full screen" div: */
  // const elem = currentElem.current;
  // hideAndShowLeftSideBar(false);
  if (document.cancelFullScreen) {
    document.cancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  }
}

//Toggle full screen both open and close
export function toggleScreen(currentElem, search) {
  // console.log("Search toggleScreen ", search);
  const elem = currentElem.current;

  if (
    (document.fullScreenElement && document.fullScreenElement !== null) ||
    (!document.mozFullScreen && !document.webkitIsFullScreen)
  ) {
    // hideAndShowLeftSideBar(true);
    if (elem.requestFullScreen) {
      elem.requestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullscreen();
    }
  } else {
    // hideAndShowLeftSideBar(false);
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
  if (window.innerHeight == window.screen.height) {
    //alert("browser exited full screen")
  }
}

// on full screen hide left side bar
export function hideAndShowLeftSideBar(isShow) {
  const ele = document.getElementById("leftSidebar");
  if (ele) {
    if (isShow) {
      ele.style.display = "none";
    } else {
      ele.style.display = "unset";
    }
  }
}
